// Capability Error Handler - Centralized error handling for 403 responses

// Event emitter for capability errors
const listeners = new Set();

export const CapabilityErrorCode = {
  TRIAL_EXPIRED: 'TRIAL_EXPIRED',
  ACCOUNT_BLOCKED: 'ACCOUNT_BLOCKED', 
  PERMISSION_DENIED: 'PERMISSION_DENIED',
  ROLE_DENIED: 'ROLE_DENIED',
};

// Subscribe to capability errors
export const onCapabilityError = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

// Emit capability error
export const emitCapabilityError = (error) => {
  listeners.forEach(callback => callback(error));
};

// Check if an error is a capability error
export const isCapabilityError = (error) => {
  if (!error?.response) return false;
  const status = error.response.status;
  const detail = error.response.data?.detail;
  
  return status === 403 && detail?.code;
};

// Get error details
export const getCapabilityErrorDetails = (error) => {
  if (!isCapabilityError(error)) return null;
  
  const detail = error.response.data.detail;
  return {
    code: detail.code,
    message: detail.message,
    trialStatus: detail.trial_status,
  };
};
